import { connect } from 'react-redux';
import DiaryGrid from './DiaryGrid';
import { bindActionCreators, Dispatch } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { getFormValues } from 'redux-form';

const mapStateToProps = (state) => ({
    formValues: getFormValues('DiaryGridFilterRow')(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DiaryGrid);
